import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/pages/Home.vue'
import Live from '../views/pages/Live.vue'
import History from '../views/pages/History.vue'
import Setting from '../views/pages/Setting.vue'
import SettingCamLists from '../views/subpages/SettingCamLists.vue'
import SettingCamDetails from '../views/subpages/SettingCamDetails.vue'
import Help from '../views/pages/Help.vue'
import HelpDetails from '../views/subpages/HelpDetails.vue'
import Flogin from '../views/pages/Flogin.vue'
import Relogin from '../views/pages/Relogin.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      redirect: '/home',
      name: '',
      component: Home,
      meta: { requiredAuth: true, title: 'ホーム | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: { requiredAuth: true, title: 'ホーム | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/live',
      name: 'Live',
      component: Live,
      meta: { requiredAuth: true, title: 'ライブ | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/history',
      name: 'History',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      component: History,
      meta: { requiredAuth: true, title: '履歴 | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/settings',
      name: 'Setting',
      component: Setting,
      meta: { requiredAuth: true, title: '設定 | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/settings/camera',
      name: 'SettingCamLists',
      component: SettingCamLists,
      meta: { requiredAuth: true, title: 'カメラ設定 | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/settings/cameradetails',
      name: 'SettingCamDetails',
      component: SettingCamDetails,
      meta: { requiredAuth: true, title: '詳細設定 | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: { requiredAuth: true, title: 'ヘルプ | LIVE Pro | IoTクラウド' }
    },
    {
      path: '/help/:id',
      name: 'HelpDetails',
      component: HelpDetails,
      meta: { requiredAuth: true, title: 'ヘルプ | LIVE Pro | IoTクラウド' }
    },
    {
      // パス先頭'*'の利用はFASTIO PLATFORMから'///flogin'でアクセスがあるため
      path: '*/flogin/:ticketToken/:termId',
      //path: '*/flogin/:ticketToken/:termId',
      name: 'flogin',
      component: Flogin,
      meta: { requiredAuth: false }
    },
    {
      // 再ログイン
      path: '*/flogin/:ticketToken',
      //path: '*/flogin/:ticketToken/:termId',
      name: 'flogin',
      component: Flogin,
      meta: { requiredAuth: false }
    },
    {
      // 再ログイン
      path: 'relogin',
      name: 'Relogin',
      component: Relogin,
      meta: { requiredAuth: false }
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
